import React, { Component } from "reactn";
import linkDS from "js/react/views/PresentationSettings/dataservices/LinkDataService";
import { DialogTitle, DialogActions, Button } from "@material-ui/core";
import {
    BeautifulDialog,
    DialogContent
} from "js/react/components/Dialogs/BaseDialog";
import * as social from "js/core/utilities/social";
import { trackActivity } from "js/core/utilities/utilities";
import slug from "slug";
import { Gap30, Gap20 } from "js/react/components/Gap";
import { ToggleAllowCommenting } from "../components/ToggleAllowCommenting";

export default class SocialShareDialog extends Component {
    constructor() {
        super();
        this.linkRef = React.createRef();

        this.state = {
            allowCommenting: false,
        };
    }

    async handleSocialAccept(network) {
        let {
            presentation,
        } = this.props;
        let {
            allowCommenting,
        } = this.state;

        let link = await linkDS.createSocialLink(presentation, network.name, allowCommenting);
        await linkDS.saveLink(presentation, link);
        this.setGlobal({
            alertMessage: "Social link was created"
        });
        const props = {
            presentation_id: presentation.id,
            link_ids: [link.get("id")],
            is_new: true,
            type: network.name,
            workspace_id: presentation.getWorkspaceId()
        };
        trackActivity("Sharing", "SocialShare", null, null, props, { audit: true });
        this.props.callback();
        social.createSharePresentationPopup(
            network.name,
            `${window.location.origin}/player/${link.id}/${slug(
                presentation.get("name")
            )}`,
            presentation.get("name")
        );
    }

    toggleAllowCommenting = event => {
        const allowCommenting = !this.state.allowCommenting;
        this.setState({ allowCommenting });
        this.forceUpdate();
    }

    render() {
        let {
            allowCommenting,
        } = this.state;

        return (
            <BeautifulDialog
                closeDialog={this.props.closeDialog}
                className="dialog-socialshare"
            >
                <DialogTitle>Social Share</DialogTitle>
                <DialogContent>
                    <h3>
                        Share a link to your presentation on these social networks.
                    </h3>
                    <Gap30 />
                    <div className="social-links">
                        {social.networks.map(network => (
                            <div
                                key={network.name}
                                className={`social button large extra ${network.name}`}
                                dangerouslySetInnerHTML={{
                                    __html: `${network.icon}<label>${network.name}</label>`
                                }}
                                onClick={() => this.handleSocialAccept(network)}
                            ></div>
                        ))}
                    </div>
                    <Gap20 />
                    <ToggleAllowCommenting
                        allowCommenting={allowCommenting}
                        onToggle={this.toggleAllowCommenting}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.closeDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
